import React from 'react'
import PropTypes from 'prop-types'

import MetaDataHelmet from '../../../Shared/MetaDataHelmet'
import JudgesContainer from './JudgesContainer'

function JudgesPage({ competitionSlug }) {
  const metaTitle = I18n.t(`competition.${competitionSlug}.meta.title.judges`)
  const metaDescription = I18n.t(`competition.${competitionSlug}.meta.description.judges`)
  const judges = I18n.t(`competition.${competitionSlug}.judges`)

  return (
    <div className="competition-partners-page">
      <MetaDataHelmet title={metaTitle} description={metaDescription} />

      <section className="content-section section--judges">
        <div className="container-fixed">
          <h2 className="content-section__title">Judges</h2>
          <p className="content-section__subtitle">
            Meet the industry experts who will be evaluating all submissions and selecting the best of the best.
          </p>

          <JudgesContainer judges={judges} />
        </div>
      </section>
    </div>
  )
}

JudgesPage.propTypes = {
  competitionSlug: PropTypes.string.isRequired,
}

export default JudgesPage
